import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { ServiceRouter, PershingError, LogService } from '@pershing/pershing-core';
import { BehaviorSubject, Observable } from 'rxjs';
import { RateBoardServiceDefinition } from './rateboard-service.definition';
import {ForeignExchangeServiceDefinition } from './foreign-exchange-service-definition';
import { FxRateObject } from '../components/models/symbol-model';
import { ModernRateBoardServiceDefinition } from './modern-rateboard-service.definition copy';

@Injectable()
export class RateBoardService {
    serviceUrl: string;
    ibd: string;
    rateBoardServiceUrl: string;
    serviceUrlModern: string;

    fxRatesServiceError$: BehaviorSubject<PershingError> = new BehaviorSubject<PershingError>(null);
    fxRatesResponse$: BehaviorSubject<any> = new BehaviorSubject<any>(null); 
    fetchingFxRatesData$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    fetchFxRatesSub: any;
    isMiddlewareJarBasedApproachEnabledForRateboard: boolean = false;
    targetedServiceUrl:string;

    constructor(private serviceRouter: ServiceRouter, private http: HttpClient, private logService: LogService,  @Optional() @Inject('AppSettings') appSettings: any) {
        this.serviceUrl = this.serviceRouter.getServiceRouteURL(RateBoardServiceDefinition.getInstance());
        this.rateBoardServiceUrl = this.serviceRouter.getServiceRouteURL(ForeignExchangeServiceDefinition.getInstance());
        this.serviceUrlModern= this.serviceRouter.getServiceRouteURL(ModernRateBoardServiceDefinition.getInstance());
        if (appSettings.ibdConfigMap.hasOwnProperty('isMiddlewareJarBasedApproachEnabledForRateboard')) {
            this.isMiddlewareJarBasedApproachEnabledForRateboard = appSettings.ibdConfigMap.isMiddlewareJarBasedApproachEnabledForRateboard;
        }
        this.fetchfxRates();
    }

    fetchfxRates(): any {
        let timeNow = Date.now();
        this.fetchingFxRatesData$.next(true);
        if (this.isMiddlewareJarBasedApproachEnabledForRateboard) {
            this.targetedServiceUrl = this.serviceUrl + '/portfolio/fxRate' + '?time=';
        } else {
            this.targetedServiceUrl = this.serviceUrlModern + '/fxRate'+ '?time=';
        }
        
        this.fetchFxRatesSub = this.http.get( this.targetedServiceUrl+ timeNow).subscribe(
            (response: HttpResponse<any>) => {
                if(this.isMiddlewareJarBasedApproachEnabledForRateboard) {
                    this.fxRatesResponse$.next(response);
                } else {
                    const data = response;
                    this.fxRatesResponse$.next(data['response']);
                }
                this.fetchingFxRatesData$.next(false);
                this.fxRatesServiceError$.next(null);
            },
            (error: HttpErrorResponse) => {
                this.logService.error('Error while fetching FxRates: ' + JSON.stringify(error));
                this.fxRatesServiceError$.next(new PershingError('Service Error', 'RateBoardService', 'System Error'));
                this.fetchingFxRatesData$.next(false);
            }
        );
        return this.fetchFxRatesSub;
    }

    fetchRateBoard(): any {
        let timeNow = Date.now();
        if (this.isMiddlewareJarBasedApproachEnabledForRateboard) {
            return this.http.get(this.serviceUrl + '/portfolio/get-rateboard' + '?time=' + timeNow); 
        } else {
            return this.fetchModernRateBoard();
        }
    }
    getForeignExchangeData(): Observable<any>{
        let timeNow = Date.now();
        return this.http.get(this.rateBoardServiceUrl + '/fxRate' + '?time=' + timeNow);
    }
    fetchModernRateBoard(): any {
        return this.http.get(this.serviceUrlModern + '/getRateboard');
    }

    ngOnDestroy(): void {
        if (this.fetchFxRatesSub) {
            this.fetchFxRatesSub.unsubscribe();
        }
    }
}
